/**
 * Stepper do onboarding — mesmo padrão visual do sheet de follow-up.
 */
import type { OnboardingStepId } from '../domain/onboardingProgress';

export const ONBOARDING_STEPPER_STEPS = [
  { id: 1 as const, label: 'Conectar o WhatsApp' },
  { id: 2 as const, label: 'Etapas do funil' },
] as const;

type Props = {
  currentStep: OnboardingStepId | null;
  isComplete?: boolean;
};

export default function OnboardingStepper({ currentStep, isComplete = false }: Props) {
  const total = ONBOARDING_STEPPER_STEPS.length;
  const current = isComplete || currentStep === null ? total : currentStep;
  const label =
    ONBOARDING_STEPPER_STEPS[current - 1]?.label ?? ONBOARDING_STEPPER_STEPS[0].label;
  const statusText = isComplete
    ? 'Concluído'
    : `Passo ${current} de ${total} — ${label}`;

  return (
    <nav aria-label="Etapas do onboarding">
      <ol className="flex gap-s1" aria-hidden={isComplete || undefined}>
        {ONBOARDING_STEPPER_STEPS.map((step) => {
          const reached = step.id <= current;
          return (
            <li key={step.id} className="min-w-0 flex-1">
              <div
                className={
                  reached
                    ? 'h-1.5 w-full rounded-full bg-primary transition-colors'
                    : 'h-1.5 w-full rounded-full bg-border transition-colors'
                }
              />
            </li>
          );
        })}
      </ol>
      <p className="mt-s2 text-sm text-muted" aria-live="polite">
        {statusText}
      </p>
    </nav>
  );
}
